var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent131(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 311,
    height: 70,
    viewBox: "0 0 311 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.999;}.b{stroke:#ff7d26;stroke-width:2px;fill:url(#a);}.c{fill:#4169e1;font-size:25px;font-family:ComicSansMS-Bold, Comic Sans MS;font-weight:700;}.d{stroke:none;}.e{fill:none;}.f{filter:url(#d);}.g{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.466,
    y1: 0.954,
    x2: 0.464,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca01"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 305,
    height: 69,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4169e1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 23,
    y: 15,
    width: 257.5,
    height: 36.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5,
    dy: 1.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffca01"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 0, -6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 302,
    height: 65,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 1,
    y: 1,
    width: 300,
    height: 63,
    rx: 3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 0, -6)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(151 43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -127.82,
    y: 0
  }, "And a shit-ton more!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent131);
export default __webpack_public_path__ + "static/media/Component13-1.0effc5d999e7fffd74bf02bac6934a1a.svg";
export { ForwardRef as ReactComponent };